<div class="toast-wrapper" [ngClass]="{'toast-success': exportStatus === LprExportStatus.COMPLETE, 'toast-failed': exportStatus === LprExportStatus.FAILED}">
  <ng-container [ngSwitch]="exportStatus">
    <ng-container *ngSwitchCase="LprExportStatus.COMPLETE">
      <sn-icon class="checkIcon">check</sn-icon>
      <span> {{ 'alpr.export.messages.success' | t }} </span>
    </ng-container>
    <ng-container *ngSwitchCase="LprExportStatus.FAILED">
      <span> {{ 'alpr.export.messages.failed' | t }} </span>
    </ng-container>
  </ng-container>
  <a href="/plates/list/exports" target="_blank" class="toast-link">
    {{ 'alpr.export.messages.viewExport' | t }}
  </a>
</div>
